import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=1d5a747c&"
import script from "./PostCreate.vue?vue&type=script&lang=js&"
export * from "./PostCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5a747c')) {
      api.createRecord('1d5a747c', component.options)
    } else {
      api.reload('1d5a747c', component.options)
    }
    module.hot.accept("./PostCreate.vue?vue&type=template&id=1d5a747c&", function () {
      api.rerender('1d5a747c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/post/PostCreate.vue"
export default component.exports